
import {  Vue, Component } from 'vue-facing-decorator';
import RegistrationAPI from '../api/modules/registration';
import Coupons from '../types/coupon';

@Component
export default class TransactionFeesMixin extends Vue {
  pricing: Coupons.CouponPercentage | null = null;
  defaultPricing: Coupons.CouponPercentage | null = null;
  couponValid: boolean = true;

  async created() {
    this.defaultPricing = await this.getPlanFees('');
  }

  // Loads up the fees for a particular coupon code
  async loadPlanFees(couponCode?: string) {
    const pricing = await this.getPlanFees(couponCode || '');
    this.pricing = pricing;
  }

  // Overrides the coupon percentage if we already have it instead of a coupon code
  setCouponPercentage(pricing: Coupons.CouponPercentage) {
    this.pricing = pricing;
  }

  // Gets the credit card fee percentage (coupon code if it exists, otherwise default)
  get ccPercentage(): number {
    let percentage = 3.5;
    if (!!this.pricing && this.pricing.CreditCard > 0) {
      percentage = this.pricing.CreditCard;
    } else if (!!this.defaultPricing && this.defaultPricing.CreditCard > 0) {
      percentage = this.defaultPricing.CreditCard;
    }
    return percentage;
  }

  // Gets the ACH fee percentage (coupon code if it exists, otherwise default)
  get achPercentage(): number {
    let percentage = 1.5;
    if (!!this.pricing) {
      if (this.pricing.BankAccount > 0) {
        percentage = this.pricing.BankAccount;
      }
    } else if (!!this.defaultPricing) {
      if (this.defaultPricing.BankAccount > 0) {
        percentage = this.defaultPricing.BankAccount;
      }
    }
    return percentage;
  }

  // Gets the check capture fee percentage (set amount)
  get checkCapturePercentage(): number {
    return 1;
  }

  // Gets the fees for a particular coupon code
  private async getPlanFees(couponCode: string): Promise<Coupons.CouponPercentage | null> {
    let couponPercentage = null;

    if ((!couponCode || couponCode === '') && !!this.defaultPricing) {
      this.couponValid = true;
      couponPercentage = this.defaultPricing;
    } else {
      try {
        let res = await RegistrationAPI.couponPricing(couponCode, {skipErrorMessaging: true});
        window.App.loader('hide');
        if (!!res) {
          this.couponValid = true;
          couponPercentage = res.data as Coupons.CouponPercentage;
        } else {
          this.couponValid = false;
        }
      } catch {
        window.App.loader('hide');
        this.couponValid = false;
      }
    }

    this.emitEvent('couponValidationChanged', this.couponValid);
    
    return couponPercentage;
  }
}
